import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import CountHeader from "./components/CountHeader";
import AssetTrends from "./components/AssetTrends";
import SharedAssets from "./components/SharedAssets";
import AssetClass from "./components/AssetClass";
import AssetDept from "./components/AssetDept";
import AssetStatus from "./components/AssetStatus";
import AssetProject from "./components/AssetProject";
import AssetMap from "@/components/AssetMap";
import AssetMapMinhang from "@/components/AssetMapMinhang";
import AssetMapPudong from "@/components/AssetMapPudong";
import AssetMapFloor from "@/components/AssetMapFloor";
import CompanySwitcher from "./components/CompanySwitcher";
import { Modal } from "antd";
export default function EAM() {
    const [modal, contextHolder] = Modal.useModal();
    const [minhangVisible, setMinhangVisible] = useState(false);
    const [pudongVisible, setPudongVisible] = useState(false);
    const [floorVisible, setFloorVisible] = useState(false);
    const minhangRef = useRef(null);
    const pudongRef = useRef(null);
    const floorUrl = useRef("");
    const floorInfo = useRef({});
    function handleClick(params) {
        if (params == "闵行区") {
            setMinhangVisible(true);
        }
        else if (params == "浦东新区") {
            setPudongVisible(true);
        }
    }
    useEffect(() => {
        if (minhangVisible) {
            minhangRef.current?.renRenderLoop?.();
        }
        else {
            minhangRef.current?.stopRenderLoop?.();
        }
    }, [minhangVisible]);
    useEffect(() => {
        if (pudongVisible) {
            pudongRef.current?.renRenderLoop?.();
        }
        else {
            pudongRef.current?.stopRenderLoop?.();
        }
    }, [pudongVisible]);
    useEffect(() => {
        if (floorVisible) {
            minhangRef.current?.stopRenderLoop?.();
        }
        else {
            minhangRef.current?.renRenderLoop?.();
        }
    }, [floorVisible]);
    const onPointClick = (pointInfo) => {
        let { pointData } = pointInfo;
        if (pointData) {
            floorInfo.current = pointInfo;
            floorUrl.current = pointData;
            setFloorVisible(true);
        }
        else {
            modal.error({
                title: "加载楼层失败",
                content: "请检查JSON数据",
            });
        }
    };
    return (_jsxs("div", { className: "flex-1 w-full p-[0.15rem] overflow-hidden min-h-0", children: [_jsx("style", { children: `
          /* 1. 最外层包裹层：四边全清 */
          .ant-modal-wrap {
            inset: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            padding-top: 0 !important;
            padding-right: 0 !important;
            padding-bottom: 0 !important;
            padding-left: 0 !important;
            overflow: hidden !important;
          }

          /* 2. AntD 6 container层：四边全清 */
          .ant-modal-container {
            margin: 0 !important;
            padding: 0 !important;
            padding-top: 0 !important;
            padding-right: 0 !important;
            padding-bottom: 0 !important;
            padding-left: 0 !important;
          }

          /* 3. 锁死页面滚动条 */
          html:has(.ant-modal-wrap),
          body:has(.ant-modal-wrap) {
            overflow: hidden !important;
            margin: 0 !important;
            padding: 0 !important;
          }

          /* 4. Modal 主体：四边全清 */
          .ant-modal {
            inset: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            max-width: 100vw !important;
            border-radius: 0 !important;
          }

          /* 5. Modal 内容层：四边全清+透明背景 */
          .ant-modal-content {
            width: 100vw !important;
            height: 100vh !important;
            margin: 0 !important;
            padding: 0 !important;
            padding-top: 0 !important;
            padding-right: 0 !important;
            padding-bottom: 0 !important;
            padding-left: 0 !important;
            border-radius: 0 !important;
            background-color: transparent !important;
          }

          /* 6. Modal body：四边全清 */
          .ant-modal-body {
            width: 100vw !important;
            height: 100vh !important;
            margin: 0 !important;
            padding: 0 !important;
            padding-top: 0 !important;
            padding-right: 0 !important;
            padding-bottom: 0 !important;
            padding-left: 0 !important;
            overflow: hidden !important;
          }
        ` }), _jsxs("div", { className: "flex flex-col flex-shrink-0 h-full", children: [_jsx(CompanySwitcher, {}), _jsx("div", { className: "h-[0.37rem] w-full mb-[0.10rem]", children: _jsx(CountHeader, { className: "w-full h-full" }) }), _jsxs("div", { className: "flex gap-[0.3rem] flex-grow min-h-0", children: [_jsxs("div", { className: "w-[4.47rem] flex flex-col gap-[0.03rem] h-full flex-shrink-0", children: [_jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(AssetTrends, { className: "w-full h-full" }) }), _jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(SharedAssets, { className: "w-full h-full" }) }), _jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(AssetClass, { className: "w-full h-full" }) })] }), _jsxs("div", { className: "flex-1 flex flex-col gap-[0.3rem] h-full min-w-0 min-h-0", children: [_jsxs("div", { className: "min-w-0 min-h-0 flex-2", children: [_jsx(AssetMap, { className: "w-full h-full", url: "/eam/screen/stat/area/0/1", onClick: handleClick }), _jsx(Modal, { open: minhangVisible, onCancel: () => setMinhangVisible(false), footer: null, destroyOnHidden: true, centered: false, children: _jsx(AssetMapMinhang, { ref: minhangRef, onPointClick: onPointClick }) }), _jsx(Modal, { open: pudongVisible, onCancel: () => setPudongVisible(false), footer: null, destroyOnHidden: true, centered: false, children: _jsx(AssetMapPudong, { ref: pudongRef, onPointClick: onPointClick }) }), _jsx(Modal, { open: floorVisible, onCancel: () => setFloorVisible(false), footer: null, destroyOnHidden: true, centered: false, children: _jsx(AssetMapFloor, { jsonUrl: floorUrl.current, floorInfo: floorInfo.current }) })] }), _jsxs("div", { className: "flex-1 flex gap-[0.2rem] min-h-0 min-w-0", children: [_jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(AssetDept, { className: "w-full h-full " }) }), _jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(AssetStatus, { className: "w-full h-full" }) }), _jsx("div", { className: "flex-1 min-w-0 min-h-0", children: _jsx(AssetProject, { className: "w-full h-full" }) })] })] })] })] })] }));
}
